import type { NotificationType } from '~/interfaces/notification';

import { useWebThemeContext } from '../Layout/Context/useWebThemeContext';
import LoadMore from './LoadMore';
import MarkAllAsRead from './MarkAllAsRead';
import NotificationsDropdown from './NotificationsDropdown';
import NotificationsList from './NotificationsList';

interface Props {
  notificationsCount: number;
  isLoading: boolean;
  notifications: NotificationType[];
  fetchMoreNotifications?: () => void;
  hasMoreToFetch?: boolean;
}

const NotificationsRenderer = ({
  notificationsCount,
  isLoading,
  notifications,
  fetchMoreNotifications,
  hasMoreToFetch,
}: Props) => {
  const hasNotifications = notificationsCount > 0;
  const { webTheme } = useWebThemeContext();

  return (
    <NotificationsDropdown
      notificationsCount={notificationsCount}
      background={webTheme?.navbar_background_color}
      color={webTheme?.navbar_text_color}
    >
      <div className="flex h-full flex-col justify-between">
        <div className="h-full">
          {hasNotifications && <MarkAllAsRead notifications={notifications} />}
          <NotificationsList
            isLoading={isLoading}
            notifications={notifications}
            textColor={webTheme?.navbar_text_color}
          />
        </div>
        {hasMoreToFetch && fetchMoreNotifications && <LoadMore fetchMoreNotifications={fetchMoreNotifications} />}
      </div>
    </NotificationsDropdown>
  );
};

export default NotificationsRenderer;
